module.exports = __webpack_public_path__ + "img/ico-wechamberfooter.4fe8eb15.svg";